// Assets
import ImageHomeCardLogoDesign from "assets/images/cards/service-card-logodesign.jpg";
import ImageHomeCardUIUXDesign from "assets/images/cards/service-card-uiuxdesign.jpg";
import ImageHomeCardWebDevelopment from "assets/images/cards/service-card-webdevelopment.jpg";
import ImageHomeCardGraphicDesign from "assets/images/cards/service-card-graphicdesign.jpg";
import ImageHomeCardMotionDesign from "assets/images/cards/service-card-motiondesign.jpg";
import ImageHomeCard3DModelling from "assets/images/cards/service-card-3dmodelling.jpg";

import ImageServiceBannerLogoDesign from "assets/images/banners/service-banner-logodesign.jpg";
import ImageServiceBannerUIUxDesign from "assets/images/banners/service-banner-uiuxdesign.jpg";
import ImageServiceBannerWebDevelopment from "assets/images/banners/service-banner-webdevelopment.jpg";
import ImageServiceBannerGraphicDesign from "assets/images/banners/service-banner-graphicdesign.png";
import ImageServiceBannerMotionDesign from "assets/images/banners/service-banner-motiondesign.jpg";
import ImageServiceBanner3DModelling from "assets/images/banners/service-banner-3dmodelling.jpg";

export const getServiceResources = (title) => {
  // Image Lookup table
  const serviceCardDetailsImageLookup = {
    "Logo Design": {
      banner: ImageServiceBannerLogoDesign,
      image: ImageHomeCardLogoDesign,
    },
    "UI/UX Design": {
      banner: ImageServiceBannerUIUxDesign,
      image: ImageHomeCardUIUXDesign,
    },
    "Web Development": {
      banner: ImageServiceBannerWebDevelopment,
      image: ImageHomeCardWebDevelopment,
    },
    "Graphic Design": {
      banner: ImageServiceBannerGraphicDesign,
      image: ImageHomeCardGraphicDesign,
    },
    "Motion Design": {
      banner: ImageServiceBannerMotionDesign,
      image: ImageHomeCardMotionDesign,
    },
    "3D Modelling": {
      banner: ImageServiceBanner3DModelling,
      image: ImageHomeCard3DModelling,
    },
  };

  return {
    banner: serviceCardDetailsImageLookup[title].banner,
    image: serviceCardDetailsImageLookup[title].image,
    title_top: title.split(" ")[0],
    title_bottom: title.split(" ")[1],
  };
};
